<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FbtCSi/tc-custom/9781681880877.jpg?1704320795197" alt="This image is the cover for the book Thanksgiving"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Thanksgiving
      </h1>
      <p class="bookDescription body article font2">
        <b>The author of <i>Fondue</i> presents a festive guide for the classic American holiday—from planning and preparation to Turkey Day recipes for every taste.</b><br/>  <br/><i>Thanksgiving</i> explores over 50 of your favorite holiday recipes, offering both traditional and contemporary dishes—from starters to stuffings and leftover ideas. With helpful tips for organizing the meal, working with turkey, and creating an inspired menu, this volume will ease the stress, making way for a wonderful Thanksgiving.<br/>  <br/> Whether you prepare and host Thanksgiving dinner every year or you are new to the experience, the task can be a daunting one. Finding the perfect turkey, timing the oven use just right, and estimating how much food and drink you need are just some of the tips and techniques that can be found in the pages of <i>Thanksgiving</i>.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lou Seibert Pappas
      </h2>
      
      <p class="authorDescription body article">Lou Seibert Pappas is the acclaimed author of more than 50 cookbooks, including Williams-Sonoma Thanksgiving Entertaining and Food Made Fast Baking in addition to Biscotti; Crêpes, Ice Creams and Sorbets; Fondue; and The Christmas Cookie Book. She lives in Northern California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Weldonowen
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?20297cba